import type { EntityLock } from "@/graphql/codegen/graphql"

export enum EntityLockStatus {
  Idle = "idle",
  Acquiring = "acquiring",
  Held = "held",
  Rejected = "rejected",
  Lost = "lost",
}

export enum MutationLockResultStatus {
  Success = "success",
  Error = "error",
  LockConflict = "lock-conflict",
}

export type AcquireResult = { ok: true; lock: EntityLock } | { ok: false; currentLock: EntityLock | null }

// `isTransportError` distinguishes a network/GraphQL transport failure (retry-worthy — the
// lock may still be live) from a server-confirmed `HeartbeatEntityLockFailure` (the lock is
// actually gone — expired, released, or taken by another user).
export type HeartbeatResult = { ok: true } | { ok: false; isTransportError: boolean }

export type MutationLockResult =
  | { status: MutationLockResultStatus.Success }
  | { status: MutationLockResultStatus.Error }
  | { status: MutationLockResultStatus.LockConflict; currentLock: EntityLock; message: string }

export interface UseEntityLockReturn {
  status: EntityLockStatus
  holder: EntityLock | null
  isReadOnly: boolean
  markLost: () => void
}
